import app from 'js/aofl-js/0.8.0/app/app';
import riqProfileStateImpl from 'readingiq-src/js/riq-js/riq-profile-state-service/1.0.0/index-impl';
import 'js/cdn-asset-service/1.0.0/index';
import 'readingiq-src/js/riq-js/access-control-service/1.0.0/index';

app.registerFactory('riqProfileStateService', [
  '$rootScope',
  'cdnAssetService',
  'accessControlService',
  riqProfileStateImpl
]);
